import { useQuery } from '@apollo/client';
import { generateClientNameString } from '@utils/generateClientNameString';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { FETCH_ACCOUNT_SNAPSHOT_LABEL } from './accountSnapshotBreadcrumb.query';

export const AccountSnapshotBreadcrumb = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { data } = useQuery(FETCH_ACCOUNT_SNAPSHOT_LABEL, {
    variables: { accountReconciliationSnapshotId: id ?? '' },
    skip: !id,
  });
  const account =
    data?.fetchAccountReconciliationSnapshot?.accountReconciliationSnapshot
      ?.account;
  if (!account) return '';

  const clientName = generateClientNameString(account.user, false, false);
  return `${clientName} - ${t(`accountTypes:${account.type}`)}`;
};
